export default "__VITE_ASSET__CWK331Co__"